import {PointTextControl} from "./PointTextControl";
import {AngleControl} from "./AngleControl";
import {ColorPopupControl} from "./ColorPopupControl";
import {FullRadiusPopupControl} from "./FullRadiusPopupControl";
import {BumpPopupControl} from "./BumpPopupControl";
import {DepthPopupControl} from "./DepthPopupControl";
import {CookTopSplashPopupControl} from "./CookTopSplashPopupControl";
import {SplashHeightPopupControl} from "./SplashHeightPopupControl";
import {LaminatePopupControl} from "./LaminatePopupControl";
import React, {useCallback, useEffect, useState} from "react";
import {ContextMenu} from "devextreme-react/context-menu";
import {ApplicationState} from "../tool/includes/applicationState";
import {ItemClickEvent} from "devextreme/ui/context_menu";
import {EEToolContextMenuItem} from "../types/EEToolContextMenuItem";
import {useEEToolAdapterContext} from "../contexts/eeToolAdapterContext";
import {Draw} from "../tool/draw";
import {useEEToolContext} from "../contexts/eeToolContext";
import {EstimatePopupControl} from "./EstimatePopupControl";
import {Button} from "devextreme-react/button";

export default function EEToolControl() {
    const adapterContext = useEEToolAdapterContext();
    const context = useEEToolContext();

    const measuredRef = useCallback(async (node: HTMLCanvasElement) => {
        if (node !== null) {
            let app = new Draw(node, adapterContext, context);
            await app.preloadData();
            app.run(context.dealerId, context.customerZip);
            adapterContext.setDrawApp(app);
        }
    }, [])

    useEffect(() => {
        return () => {
            if (adapterContext.drawApp) {
                adapterContext.drawApp.remove();
                adapterContext.setDrawApp(undefined);
            }
        }
    }, [adapterContext.drawApp]);

    useEffect(() => {
        if (adapterContext.drawApp) {
            if (adapterContext.isEstimate) {
                adapterContext.drawApp.isEstimate = true;
                adapterContext.drawApp.updateEstimate();
            } else {
                adapterContext.drawApp.isEstimate = false;
            }
        }
    }, [adapterContext.isEstimate]);


    return <div>
        <PointTextControl/>
        <AngleControl/>
        <ColorPopupControl/>
        <FullRadiusPopupControl/>
        <BumpPopupControl/>
        <DepthPopupControl/>
        <CookTopSplashPopupControl/>
        <SplashHeightPopupControl/>
        <LaminatePopupControl/>
        <EstimatePopupControl></EstimatePopupControl>
        <Button text={'Estimate'} style={{position: 'fixed', bottom: '16px', right: '100px'}} onClick={() => {
            adapterContext.setIsEstimate(true);
        }}></Button>
        <canvas className="ee-tool-canvas ee-tool-pencil-cursor" id="canvas" ref={measuredRef} width={500}
                height={500}/>
        <ContextMenu
            dataSource={adapterContext.contextMenuItems}
            target="#canvas"
            showEvent='dxcontextmenu customeetoolcontentmenu'
            onPositioning={(e) => {
                if (e.event?.type === "customeetoolcontentmenu") {
                    e.position.offset = {
                        x: ApplicationState.contextMenuX,
                        y: ApplicationState.contextMenuY
                    }
                    e.position.of = '#canvas';
                }
            }}
            onItemClick={(e: ItemClickEvent<EEToolContextMenuItem>) => {
                if (e.itemData) {
                    let item = e.itemData as EEToolContextMenuItem;
                    if (item.fun) {
                        item.fun();
                    }
                }
            }}
            onHidden={() => {
                if (adapterContext.contextMenuOnHidden) {
                    adapterContext.contextMenuOnHidden();
                }
            }}
        />
    </div>;
}